import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import * as Color from 'color';
import * as Parse from 'parse';
import { OrganizationService } from './organization.service';
import { AppConfigService } from './app-config.service';

export type SettingsFileCategory = 'largeBanner' | 'smallBanner' | 'largeLogo' | 'smallLogo';

@Injectable()
export class SettingsService {
    public largeLogoUploading: boolean = false;
    public smallLogoUploading: boolean = false;
    public largeBannerUploading: boolean = false;
    public smallBannerUploading: boolean = false;

    get logo() {
        if (this.orgService.organization?.has('smallLogo') && this.orgService.organization?.get('smallLogo')) {
            return this.orgService.organization.get('smallLogo').url();
        }

        return this.appConfig.parseConfig?.get('defaultSmallLogo').url();
    }

    get largeLogo() {
        const fallbackLogoUrl = './assets/img/logoMark.svg';

        if (this.orgService.organization?.has('largeLogo') && this.orgService.organization?.get('largeLogo')) {
            return this.orgService.organization.get('largeLogo').url();
        }

        return fallbackLogoUrl;
        //return this.appConfig.parseConfig?.get('defaultLargeLogo').url();
    }

    constructor(
        private orgService: OrganizationService,
        private appConfig: AppConfigService
    ) {}

    uploadFile(file: File, category: SettingsFileCategory) {
        const fileName: string = file.name.replace(/.*\./gi, category + '_' + Math.random().toString(16).replace('.', '_') + '.');
        const parseFile: Parse.File = new Parse.File(fileName, file);

        this.orgService.organization.set(category, parseFile);

        return this.orgService.organization.save();
    }

    updateAppColors() {
        if (this.orgService.organization?.has('primaryColor') && this.orgService.organization?.get('primaryColor') !== '') {
            this.updateAppPrimaryColor();
        }

        if (this.orgService.organization?.has('secondaryColor') && this.orgService.organization?.get('secondaryColor') !== '') {
            this.updateAppSecondaryColor();
        }
    }

    hexToRgb(hex: string) {
        // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
        let shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
        hex = hex.replace(shorthandRegex, function(m, r, g, b) {
            return r + r + g + g + b + b;
        });

        let result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        return result ? {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16)
        } : null;
    }


    getContrastColor(color: any, ratio = 0.8) {
        color = Color(color);
        return color.isDark() ? color.lighten(ratio) : color.darken(ratio);
    }


    updateAppPrimaryColor() {

        // await this.fetchParseConfig();

        const shadeRatio = 0.3;
        const tintRatio = 0.3;

        const newPrimaryColor = this.orgService.organization.get('primaryColor');
        const newPrimaryColorRGB = this.hexToRgb(newPrimaryColor);
        const newPrimaryColorRGBStr = newPrimaryColorRGB?.r + ',' + newPrimaryColorRGB?.g + ',' + newPrimaryColorRGB?.b;
        // const newPrimaryContrast = this.getContrastColor(newPrimaryColor);
        const newPrimaryContrast = '#fff';
        const newPrimaryContrastRGB = '255,255,255';
        const newPrimaryColorShade = Color(newPrimaryColor).darken(shadeRatio);
        const newPrimaryColorTint = Color(newPrimaryColor).lighten(tintRatio);

        const root = document.documentElement;
        root.style.setProperty('--ion-color-primary', newPrimaryColor);
        root.style.setProperty('--ion-color-primary-rgb', newPrimaryColorRGBStr);
        root.style.setProperty('--ion-color-primary-contrast', newPrimaryContrast);
        root.style.setProperty('--ion-color-primary-contrast-rgb', newPrimaryContrastRGB);
        root.style.setProperty('--ion-color-primary-shade', newPrimaryColorShade as any);
        root.style.setProperty('--ion-color-primary-tint', newPrimaryColorTint as any);

    }

    updateAppSecondaryColor() {
        const shadeRatio = 0.3;
        const tintRatio = 0.3;

        const newSecondaryColor = this.orgService.organization.get('secondaryColor');
        const newSecondaryColorRGB = this.hexToRgb(newSecondaryColor);
        const newSecondaryColorRGBStr = newSecondaryColorRGB?.r + ',' + newSecondaryColorRGB?.g + ',' + newSecondaryColorRGB?.b;
        // const newSecondaryContrast = this.getContrastColor(newSecondaryColor);
        const newSecondaryContrast = '#fff';
        const newSecondaryContrastRGB = '255,255,255';
        const newSecondaryColorShade = Color(newSecondaryColor).darken(shadeRatio);
        const newSecondaryColorTint = Color(newSecondaryColor).lighten(tintRatio);

        const root = document.documentElement;
        root.style.setProperty('--ion-color-secondary', newSecondaryColor);
        root.style.setProperty('--ion-color-secondary-rgb', newSecondaryColorRGBStr);
        root.style.setProperty('--ion-color-secondary-contrast', newSecondaryContrast);
        root.style.setProperty('--ion-color-secondary-contrast-rgb', newSecondaryContrastRGB);
        root.style.setProperty('--ion-color-secondary-shade', newSecondaryColorShade as any);
        root.style.setProperty('--ion-color-secondary-tint', newSecondaryColorTint as any);

    }
}
